import { UserOutlined } from "@ant-design/icons";
import { Button, Flex, Form, Input, notification } from 'antd';
import { NotificationPlacement } from "antd/es/notification/interface";
import { createContext, FC, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { RouteNames } from "../../../router/routeNames";
import { useStoreDispatch } from "../../../store";
import {Login, Registration, setAuth, setUserInfo} from '../../../store/users';
import s from '../form/form.module.scss';
import { EmailInputIcon, EyeIcon, LockIcon, openEyeIcon } from '../../../assets/image/svg';
import Icon from "@ant-design/icons/lib/components/Icon";
import Cookies from 'js-cookie';

const Context = createContext({ name: 'Default' });

interface IClickLogin {
    clickLogin: () => void
}

const RegistrationForm: FC<IClickLogin> = ({clickLogin}) => {
    const dispatch = useStoreDispatch()
    const router = useNavigate()
    const [api, contextHolder] = notification.useNotification();

    const onFinish = async (data: any) => {
        data.role_id = 2
        data.group_id = 1
        const result = await dispatch(Registration(data));
        const jRes = JSON.parse(result.payload);
        if (jRes.success === 1) {
            sessionStorage.setItem('_yl105000', jRes.user);
            dispatch(setAuth(true));
            dispatch(setUserInfo(jRes.name));
            router(RouteNames.MAIN);
        }
        if (jRes.success === 0) {
            dispatch(setAuth(false));
            openNotification('topRight', jRes.message);
        }
    }

    const openNotification = (placement: NotificationPlacement,message: string) => {
        api.error({
            message: `Ошибка`,
            description: <Context.Consumer>{({ name }) => message}</Context.Consumer>,
            placement,
        });
    };

    const contextValue = useMemo(() => ({ name: '' }), []);

    return (
        <Context.Provider value={contextValue}>
            {contextHolder}
            <Flex align={'center'} vertical>
            <div className={s.container}>
                <h1 style={{marginBottom: 30, textAlign: 'center', fontFamily: 'Manrope', fontSize: 32, fontWeight: 700 }}>Регистрация аккаунта</h1>
                <Form onFinish={onFinish} layout="vertical">
                    <Form.Item
                        name="name"
                        rules={[{required: true, message: 'Пожалуйста, укажите Ваше имя!'}]}>
                        <Input
                            placeholder="Имя"
                            prefix={<UserOutlined />}
                            style={{marginBottom: 5}}
                        />
                    </Form.Item>
                    <Form.Item
                        name="last_name"
                        rules={[{required: true, message: 'Пожалуйста, укажите Вашу фамилию!'}]}>
                        <Input
                            placeholder="Фамилия"
                            prefix={<UserOutlined />}
                            style={{marginBottom: 5}}
                        />
                    </Form.Item>
                    <Form.Item
                        name="first_name">
                        <Input
                            placeholder="Отчество"
                            prefix={<UserOutlined />}
                            style={{marginBottom: 5}}
                        />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        rules={[{
                            type: 'email', message: 'Введенный адрес электронной почты неверен!'},
                            {required: true, message: 'Пожалуйста, введите свой адрес электронной почты!'
                        }]}>
                        <Input
                            placeholder="Email"
                            prefix={<EmailInputIcon />}
                            style={{marginBottom: 5}}
                        />
                    </Form.Item>
                    <Form.Item name="password" className={s.smallStep} rules={[{required: true, message: 'Пожалуйста, введите свой пароль!'}]}>
                        <Input.Password
                            prefix={<LockIcon/>}
                            style={{marginBottom: 5}}
                            type={"password"}
                            placeholder="Пароль"
                            iconRender={(visible) => (visible ?  <Icon component={openEyeIcon}/> : <Icon component={EyeIcon}/>)}
                        />
                    </Form.Item>
                    <Form.Item name="repeat_password" className={s.smallStep} rules={[{required: true, message: 'Пожалуйста, повторите пароль!'}]}>
                        <Input.Password
                            prefix={<LockIcon/>}
                            type={"password"}
                            placeholder="Повторите пароль"
                            iconRender={(visible) => (visible ?  <Icon component={openEyeIcon}/> : <Icon component={EyeIcon}/>)}
                        />
                    </Form.Item>
                    <Form.Item name="button" className={s.bigStep} >
                        <Flex align={'center'} vertical>
                            <Button type={'primary'} block htmlType={'submit'}>
                                Регистрация
                            </Button>
                            <p style={{color: '#0055FF'}} onClick={clickLogin} className={s.ahref}>или войдите</p>
                        </Flex>
                    </Form.Item>
                </Form>
            </div>
            </Flex>
        </Context.Provider>
    );
};

export default RegistrationForm;
